export default {
  LINK_SOWOS_WEALTH_MODERATE_COMMAND: Symbol.for('LINK_SOWOS_WEALTH_MODERATE_COMMAND'),
  LINK_SOWOS_WEALTH_MODERATE_REPOSITORY: Symbol.for('LINK_SOWOS_WEALTH_MODERATE_REPOSITORY'),
};
